<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          'The properties displayed on this tab are specific to DirectMatch. ',
        ],
      },
      {
        header: 'General Properties',
      },
      {
        header: 'Index ID Display Format',
        body: [
          'Indicates how the Index ID will be displayed throughout the application',
        ],
      },
      {
        header: 'Default Properties',
        body: [
          'The Extract Downloadable Types Allowed should include the DM Index type.',
        ],
      },
      {
        header: 'CEP Properties',
        body: [
          `The CEP properties contain the state population submission dates, 
          the election due date, enrollment cut-off date, the ISP multiplier, and the current school year.`,
        ],
      },
      {
        header: 'State Match',
        body: [
          `Split Batch Option for Extracts-selecting “by LEAs” allows the state batch to be divided into 
          local education agency files for download by each LEA for use in their local systems.`,
        ],
      },
      {
        header: 'Programs',
        body: [
          `The available programs such as Foster, Medicaid, SNAP or TANF, should be listed under programs 
          along with their Last Index Date, Status and Match or CEP Enabled status.`,
          `Matching rules and other validations for DirectMatch are available in Rule Manager.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
